import React from "react";
import { Image } from "@react-pdf/renderer";
import { getStudyLogo } from "../studyLogo";

// Box requested by the studies, relative to the right-hand header (which starts at the middle of the page).
// The API crops the logo's blank margins so it fills this box.
const logoStyle = { position: "absolute", left: -240, top: -8, width: 236, height: 56, objectFit: "contain", objectPosition: "left center" };

export default function StudyLogoPDF({ user }) {
  const logo = getStudyLogo(user);
  if (!logo) return null;

  return <Image src={logo} style={logoStyle} />;
}
